<template>
	<g ref="smoke">
		<path  id="one" fill="#E3E8E6" d="M246.3,868.7c0,0-57.1-57.2,46.9-50.1c104,7.2,264.3,17.4,258.6-34.7c-5.7-52.1-62.4-76.2-87.5-80.7
	c-68.2-12.3-254.2-4.1-271.9-59.3c-3.3-10.3,46.1-38.2,46.1-38.2S-48.3,649,60.6,708.2c62.1,24.5,107.8,32.7,169.9,28.6
	c62.1-4.1,209.2-18.4,190.2,6.1s-50.1,37.8-81.8,39.9c-86,5.5-122.2,12-133.1,18.4C160.1,827.8,201.9,856.4,246.3,868.7"/>
		<path  id="two" fill="#E3E8E6" d="M243,605.7c0,0,155-36.2,154-46.7c-0.8-9-86.9-31.3-170-46c-158-28-49-72,9-75s58-3,58-3s-95,44-8,61
	c167.2,32.7,224.8,52.9,225,65.3c0.1,2.4-1.9,4.8-4,5.7C451,591.7,243,605.7,243,605.7z"/>
		<path  id="three" fill="#E3E8E6" d="M309,382.3c-33.3-39.3,84.1-59.6,135.7-69.9c99.2-20-95.4-89.2-95.4-89.2S463,292,368,297
	c-32.5,1.7-180.3,26-87,85.3c36.5,23.2,20.3,46.4,20.3,46.4S329.9,407,309,382.3z"/>
		<path   id="fo" fill="#E3E8E6" d="M261,112.6c25.3-24,102.7-39.9,91.8-88.3c-0.8-3.4-4.5-14.5-4.5-14.5s40.4,39.5,42,60.8
	c2,26-75,42.3-82.3,56.3s34.3,88.4,34.3,88.4S235.7,136.6,261,112.6z"/>
	</g>
</template>

<script>
	import { TweenMax  } from 'gsap'

	export default {
		mounted() {
			TweenMax.staggerTo(["#one", "#two", "#three", "#fo"],4, {opacity: 0, repeat:-1, yoyo: true}, 1)
		}
	}
</script>

<style lang="scss">


</style>
